// extracted by mini-css-extract-plugin
module.exports = {"BgImg":"ConverterMainSection_BgImg__1fU83"};